<footer *ngIf="!isMobileChannel">
  <div class="footer-wrap desktop-400">
    <div class="social">
      <div class="row">
        <div class="ovr-col-xs-9 col-xs-9 col-sm-8 col-md-7 col-lg-7">
          <form ngNoForm action="/email/" method="post">
            <div class="input-group">
              <label for="newsletter">Sign up for our email newsletter</label>
              <input class="form-control" type="email" placeholder="Email Address" id="newsletter" name="email">
              <div class="input-group-append">
                <button class="btn" type="submit" title="Go" aria-label="Go">Go</button>
              </div>
            </div>
          </form>
        </div>
        <div class="ovr-col-xs-3 col-xs-3 col-sm-4 col-md-5 col-lg-5 follow-us">
          <ul role="list">
            <li role="listitem">
              <p>Follow us on:</p>
            </li>
            <li>
              <a id="anchorTag1" href="http://www.facebook.com/CVS" title="Follow us on Facebook"><span
                class="foot-icon facebook-icon"></span></a>
            </li>
            <li>
              <a id="anchorTag2" href="http://twitter.com/CVS_Extra" title="Follow us on Twitter"><span
                class="foot-icon twitter-icon"></span></a>
            </li>
            <li>
              <a id="anchorTag3" href="http://www.youtube.com/cvspharmacyvideos" title="Follow us on Youtube"><span
                class="foot-icon youtube-icon"></span></a>
            </li>
            <li>
              <a id="anchorTag4" href="/mobility" title="Follow us on your Phone"><span
                class="foot-icon cellphone-icon"></span></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="nav-links">
      <div class="row">
        <div class="col-xs-4 col-sm-5 col-md-3 col-lg-3">
          <ul>
            <li><h3><a href="/pharmacy/pharmacy-homepage.jsp" aria-label="pharmacy-service-link">Pharmacy Services</a></h3></li>
            <li><a href="/drug">Drug Information Center</a> </li>
            <li><a href="http://health.cvs.com/">Health Information Center</a> </li>
            <li><a href="/checkout/rx/rx_new_prescription.jsp?flow=rx&passedTransactionType=new">New Prescriptions</a> </li>
            <li><a href="/pharmacy/center.jsp?tab=summary">Refill Prescriptions</a> </li>
            <li><a href="/#/pharmacy/rxTransfer" (click)="initiateTransfer($event)">Transfer Rx to CVS</a> </li>
            <li><a href="/pharmacy/center.jsp?tab=order_history">View/Print Prescription History</a> </li>
            <li><a href="/checkout/rx/rx_express_refill_container.jsp">Rapid Refill</a> </li>
            <li><a href="/bizcontent/general/footer/pharmacy-customer-bill-of-rights-for-language-services.pdf">New York Patient Bill of Rights</a> </li>
            <li><a href="https://apps.health.ny.gov/pdpw/SearchDrugs/Home.action">NY Prescription Drug Price List</a> </li>
          </ul>
        </div>
        <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2">
          <ul>
            <li><h3><a href="/store-locator/landing" aria-label="pharmacy-stores-link"> CVS/pharmacy Stores</a></h3></li>
            <li><a href="/store-locator/landing">Store Locator</a> </li>
            <li><a href="/giftcards">CVS/pharmacy Gift Cards</a> </li>
            <li><a href="/account/sso/intersite-sso-service.jsp?target=photo">CVSphoto</a> </li>
            <li><a href="/shop/online-deals/_/N-3vZ2k?pt=SHOP&searchTerm=money-center">Money Center</a> </li>
            <li><a href="/minuteclinic/">MinuteClinic</a> </li>
            <li><a href="/content/hearingcenter">Hearing Center</a> </li>
            <li><a href="/content/optical">Optical Center</a> </li>
          </ul>
          <ul>
            <li><h3>
              <a href="/account/my-account.jsp" aria-label="myaccount-link"> My Account</a>
            </h3></li>
            <li><a href="/account/order-status-and-history.jsp">Order Status</a> </li>
          </ul>
        </div>
        <div class="col-xs-4 col-sm-3 col-md-2 col-lg-2">
          <ul>
            <li><h3>
              <a href="/deals/deals.jsp" aria-label="deals-link">Deals</a>
            </h3></li>
            <li><a href="/myweeklyad">Weekly Ad</a></li>
            <li><a href="/onlinesales">Online Offers</a></li>
            <li><a href="http://print.coupons.com/alink.asp?go=14415oj9710">In-Store Offers</a></li>
          </ul>
          <ul>
            <li><h3>
              <a href="/extracare/landing.jsp" class="promoLinkred" aria-label="extracare-link">ExtraCare</a>
            </h3></li>
          </ul>
          <ul>
            <li><h3>
              <a href="/mobile-cvs" aria-label="mobile-link">Mobile</a></h3></li>
            <li><a href="/mobile-cvs/sites">Mobile Sites</a></li>
            <li><a href="/mobile-cvs/apps">Mobile App</a></li>
          </ul>
        </div>
        <div class="col-xs-4 col-sm-5 col-md-2 col-lg-2">
          <ul>
            <li><h3>
              <a href="/help/help_index.jsp" aria-label="help-link">Help</a>
            </h3></li>
            <li><a href="/help/help_contact_us.jsp">Contact Us</a></li>
            <li><a href="/returnpolicy">Return Policy</a></li>
            <li><a href="/shippinginformation">Shipping Information</a></li>
            <li><a href="/help/privacy_policy.jsp">Privacy Policy</a></li>
            <li><a href="/help/sitemap/sitemap.jsp">Site Map</a></li>
            <li><a href="/help/help_subtopic_details.jsp?subtopicName=Security+Alerts&topicid=2400003">Security</a></li>
            <li><a href="/bizcontent/general/CVS_Pharmacy_Nondiscrimination_Policy.pdf" target="_blank" rel="noopener noreferrer">Non-Discrimination Policy</a></li>
          </ul>
          <ul>
            <li><h3>
              <a href="http://www.caremark.com/" aria-label="benefit-management-link">Prescription Benefit Management</a>
            </h3></li>
            <li><a href="http://www.caremark.com/">Caremark.com</a> </li>
          </ul>
        </div>
        <div class="col-xs-4 col-sm-4 col-md-3 col-lg-3">
          <ul>
            <li><h3><a href="http://www.cvshealth.com/"
                                    aria-label="corporate-info-link">Corporate Information</a>
            </h3></li>
            <li><a href="http://www.cvshealth.com/">CVSHealth.com</a></li>
            <li><a href="http://investors.cvshealth.com/">Investors</a></li>
            <li><a href="http://www.cvshealth.com/newsroom">Newsroom</a></li>
            <li><a href="http://www.cvshealth.com/social-responsibility">Social Responsibility</a></li>
            <li><a href="http://jobs.cvshealth.com/article/retail-jobs">Careers</a></li>
            <li><a href="http://www.cvshealth.com/patient-privacy">Patient Privacy</a></li>
            <li><a href="http://www.cvshealth.com/social-responsibility/corporate-social-responsibility/ethics-and-human-rights">Ethics & Human Rights</a></li>
            <li><a href="http://www.cvscaremarkrealty.com/">Real Estate</a></li>
            <li><a href="http://www.cvspharmacyacquisitions.com/">Sell Your Pharmacy</a></li>
            <li><a href="http://www.cvssuppliers.com/">Suppliers</a></li>
            <li><a href="https://www.silverscript.com/" target="_blank" rel="noopener noreferrer">SilverScript.com</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="feedback_wraper">
      <a class="anchorTag51" href="javascript:void(0);" (click)="triggerOpinionLab()">
        <img [src]="feedback_gif" border="0" title="Please give us your feedback, opens Feedback external site in a new window"
             alt="">Feedback</a>
    </div>
  </div>
  <div *ngIf= "!isMobileChannel" class="mdp-footer desktop-400 flex-row">
    <div class="column-xs-12 footer-links">
      <div class="links">
        <a href="tel:18007530596">1-800-753-0596</a><span>|</span>
        <a href="https://www.cvs.com/help/terms_of_use.jsp" target="_blank" rel="noopener noreferrer">Terms of Use</a><span>|</span>
        <a href="https://www.cvs.com/accessibility" target="_blank" rel="noopener noreferrer">Accessibility</a><span class="accessibility-link">|</span>
        <a href="https://www.cvs.com/help/privacy_policy.jsp" target="_blank" rel="noopener noreferrer">Privacy Policy</a><span>|</span>
        <span>© Copyright 1999 - {{year}}<a href="https://www.cvs.com" target="_blank" rel="noopener noreferrer">CVS.com</a> </span>
      </div>
      <div class="mdp-vipps">
        <a href="http://www.nabp.pharmacy/programs/vipps/vipps-accredited-pharmacies-list/" target="_blank" rel="noopener noreferrer">
          <img [src]="vipps_logo" alt="Visit VIPPS">
        </a>
      </div>
    </div>
  </div>
  <div class="un_footer mobile-400" >
    <div class="un_bgline" style="border-top:3px solid #CC0000;">
      <div class="un_social">
        <span class="un_bold un_rspace5">Follow us</span>
        <span class="un_lspace5 un_rspace5"><a class="un_vert" href="http://www.facebook.com/CVS"><span class="foot-icon facebook-icon scale-icon"></span></a></span>
        <span class="un_lspace5 un_rspace5"><a class="un_vert" href="http://twitter.com/CVS_Extra"><span class="foot-icon twitter-icon scale-icon"></span></a></span>
        <span class="un_lspace5 un_rspace5"><a class="un_vert" href="http://www.youtube.com/cvspharmacyvideos"><span class="foot-icon youtube-icon scale-icon"></span></a></span>
      </div>
    </div>
    <div class="un_app">
      <a class="un_app_link" onclick="pixel_conversion('4107')"
         href="http://itunes.apple.com/us/app/cvs-pharmacy/id395545555?mt=8">
        Get Our FREE App
        <span class="un_lspace5"><img class="un_vert app_store_img" [src]="app_store_icon"></span>
      </a>
    </div>
    <div class="un_tspace10">
      <a href="/account/my-account.jsp">My Account</a>
    </div>
    <div>
      <a href="/mt/phone_link?phone=tel%3A18006799691">866-213-7083</a> | <a href="javascript:void(0);" (click)="triggerOpinionLab()">Feedback
        <span class="sr-only"> Will open a new window</span>
      </a>
    </div>
    <div>
      <a href="/mt/stop_mobi?url=http%3A%2F%2Fwww.cvs.com&amp;time=session">Desktop Site</a> | <a href="/help/terms_of_use.jsp">Terms of Use</a>            | <a href="/help/privacy_policy.jsp">Privacy Policy</a>
    </div>
    <div class="copyrighttest">
      &copy; Copyright 1999 - {{year}} CVS.com
    </div>
  </div>
</footer>
